import { createEntityCollectionStore } from '@core/ngrx-legacy';
import { CareersJobPageLayout } from '@recruitee/careers-site-types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<CareersJobPageLayout>()('CareersJobPageLayouts');

const CareersJobPageLayoutsActions = {
  fetchCollection: actions.fetchCollection,
  fetchCollectionSuccess: actions.fetchCollectionSuccess,
  fetchCollectionFailed: actions.fetchCollectionFailed,
};

export {
  CareersJobPageLayoutsActions,
  selectors as CareersJobPageLayoutsSelectors,
  reducer as CareersJobPageLayoutsReducer,
  namespace as CareersJobPageLayoutsNamespace,
};
